import { useState } from "react";
import { Link } from "react-router-dom";
import apiClient, { formatApiError } from "@/lib/apiClient";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

const EMBLEM = "https://static.prod-images.emergentagent.com/jobs/e7aa276a-5de1-4c83-900c-894e1c7268a2/images/df5b7e9d7d3c0712e0fada815b5b10f3496a96f18ade7bc4231629bb9c81c851.jpeg";
const inputCls = "mt-2 w-full h-11 px-3.5 rounded-md border border-slate-300 bg-white text-sm focus:ring-2 focus:ring-slate-900 focus:border-slate-900 focus:outline-none transition";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await apiClient.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Something went wrong.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAFAFA] grain">
      <div className="w-full max-w-sm" data-testid="forgot-password-page">
        <div className="inline-flex bg-black rounded-lg p-2 mb-6"><img src={EMBLEM} alt="Proposal Forensics" className="h-10 w-10 object-contain" /></div>
        <h2 className="font-display font-extrabold text-3xl tracking-tight text-[#0F172A]">Reset your password</h2>
        <p className="text-slate-500 mt-2 text-sm">Enter your account email and we'll send you a secure reset link.</p>

        {!sent ? (
          <form onSubmit={submit} className="space-y-5 mt-8">
            <div>
              <label className="font-mono-plex text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-500">Email</label>
              <input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@company.com" className={inputCls} />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
            <button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full h-11 bg-[#0F172A] hover:bg-[#1E293B] text-white rounded-md font-semibold text-sm flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
              <EnvelopeSimple size={16} weight="bold" /> {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="mt-8 space-y-4" data-testid="forgot-success">
            <div className="text-sm text-slate-600 bg-emerald-50 border border-emerald-200 rounded-md px-4 py-3">
              If an account exists for <span className="font-semibold">{email}</span>, a password reset link has been sent.
            </div>
          </div>
        )}

        <Link to="/login" data-testid="back-to-login" className="mt-8 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors">
          <ArrowLeft size={15} weight="bold" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
